import { render, staticRenderFns } from "./commentView.vue?vue&type=template&id=0adf8030&scoped=true&"
import script from "./commentView.vue?vue&type=script&lang=ts&"
export * from "./commentView.vue?vue&type=script&lang=ts&"
import style0 from "./commentView.vue?vue&type=style&index=0&id=0adf8030&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adf8030",
  null
  
)

export default component.exports